import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import HomePageModel from "../../models/transaction/homepage-model";
import { LoadingIndicator } from "../../core/loading-indicator.component";
import dayjs from "dayjs";

export interface DashboardCountRef {
  refresh: () => void;
}

export interface DashboardCountProps {
  inactiveClass?: string;
  porderDate?: Date;
}

const DashboardCount = forwardRef<DashboardCountRef, DashboardCountProps>(
  ({ inactiveClass, porderDate }, ref) => {


    const [orderDate, setOrderDate] = useState<string>("");
    const [homePageDetail, setHomepagedetail] = useState<HomePageModel[]>([]);
    const [isLoadingHome, setIsLoadingHome] = useState(false);
    const active = "gredientBg card p-4 border-0 sw-shadow radius-15 border-0";

    const fetchData = async (orddate: string) => {
      const url =
        getEndPoint(API_END_POINT.ORDER) +
        `/api/HomePage/GetHomePageDetails/${orddate}`;
      try {
        setIsLoadingHome(true);
        const response = await getDataWithToken<any>(url);
        const detail = response?.data?.result || [];
        setHomepagedetail(detail);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoadingHome(false);
      }
    };

    useEffect(() => {
      // const today = new Date();
      // const day = today.getDate().toString().padStart(2, "0");
      // const month = (today.getMonth() + 1).toString().padStart(2, "0");
      // const year = today.getFullYear();
      // const formattedDate = `${year}-${month}-${day}`;
      
      const formattedDate =  dayjs(porderDate).format('YYYY-MM-DD');
      setOrderDate(formattedDate);
      fetchData(formattedDate);
    }, [porderDate]);

    useImperativeHandle(ref, () => ({
      refresh() {
        if (orderDate) {
          fetchData(orderDate);
        }
      },
    }));
    return (
      <>
        {isLoadingHome ? (
          <LoadingIndicator isLoading={isLoadingHome} title="reloading.." /> // your spinner component or loading text
        ) : (
          homePageDetail.map((item, index) => (
            <div className="boxcount mb-4" key={index}>
              <div style={{ cursor: "pointer" }} className={active}>
                <h5 className="text-uppercase">
                  AGENTS <span className="fw-bold">ORDER</span>
                </h5>
                <h1 className="indication2">{item.agentOrder}</h1>
              </div>
              <div style={{ cursor: "pointer" }} className={active}>
                <h5 className="text-uppercase">
                  CUSTOMERS <span className="fw-bold">ORDER</span>
                </h5>
                <h1 className="indication2">{item.cardOrder}</h1>
              </div>
              <div style={{ cursor: "pointer" }} className={active}>
                <h5 className="text-uppercase">
                  MORNING <span className="fw-bold">QUANTITY</span>
                </h5>
                <h1 className="indication2">{item.morningQty}</h1>
              </div>
              <div style={{ cursor: "pointer" }} className={active}>
                <h5 className="text-uppercase">
                  EVENING <span className="fw-bold">QUANTITY</span>
                </h5>
                <h1 className="indication2">{item.eveningQty}</h1>
              </div>
              <div style={{ cursor: "pointer" }} className={active}>
                <h5 className="text-uppercase">
                  TOTAL <span className="fw-bold">QUANTITY</span>
                </h5>
                <h1 className="indication2">{item.totalQty}</h1>
              </div>
            </div>
          ))
        )}
      </>
    );
  }
);

export default DashboardCount;
